import ApiError from "api/utils/apiError";
import { LOCK_BY_CAPTCHA_STATUS_CODE } from "src/constants";

const isLockedByCaptcha = (error: ApiError) =>
  error.status === LOCK_BY_CAPTCHA_STATUS_CODE;

export default isLockedByCaptcha;
